import React from 'react';
import { get } from 'global/lib/lodash';
import useRetrieveData from 'global/hooks/useRetrieveData';
import { getTaskStatus } from 'global/utils';
import Comment from 'global/components/comment';
import useStyles from './tasksComments.styles';

const TaskComments = ({ task, closedOnly }) => {
  const { data } = useRetrieveData(
    { url: `/tasks/${task.id}` },
    { build: ['tasks'], params: { include: 'comments,comments.author,comments.images' }, transformData: (d) => get(d, '0', {}) }
  );

  return get(data, 'comments', []).map((comment) => {
    const status = get(comment, 'meta.status', 0);
    const canShow = closedOnly ? status === 2 : true;
    return !canShow ? null : <Comment key={comment.id} {...comment} />;
  });
};

export default (props) => {
  const closedOnly = get(props, 'closedOnly', true);
  const classes = useStyles();

  const tasks = get(props, 'tasks', []).filter((task) => {
    if (closedOnly) {
      return getTaskStatus(task).title === 'closed';
    } else {
      return true;
    }
  });

  return (
    <div className={classes.correction}>
      {tasks.map((task) => (
        <TaskComments key={task.id} task={task} closedOnly={closedOnly} />
      ))}
    </div>
  );
};
